export const zhCN = {
  // 主题
  theme: {
    switchToLight: '亮色主题',
    switchToDark: '暗色主题',
    switchToLightTooltip: '切换到亮色主题',
    switchToDarkTooltip: '切换到暗色主题'
  },

  // 导航菜单
  nav: {
    menu: '导航菜单',
    home: '首页',
    about: '关于创美',
    news: '新闻资讯',
    careers: '人才招聘',
    investor: '投资者关系',
    stockInfo: '股票信息',
    contact: '联系我们'
  },

  // 头部导航
  header: {
    supplierService: '供应商服务',
    drugTestQuery: '药检单查询'
  },

  // 导航
  navigation: {
    home: '首页',
    about: '关于创美',
    aboutCompany: '公司简介',
    aboutHistory: '发展历程',
    aboutHonors: '荣誉资质',
    aboutOrganization: '组织架构',
    aboutTeam: '员工风采',
    aboutLogistics: '物流配送中心',
    aboutCulture: '企业文化',
    news: '新闻资讯',
    careers: '人才招聘',
    careersRecruitment: '社会招聘',
    careersSocial: '社会招聘',
    careersCampus: '校园招聘',
    investor: '投资者关系',
    investorService: '投资者服务',
    stockInfo: '股票信息',
    investorAnnouncements: '公告及通函',
    investorFinancialReports: '财务报告',
    investorGovernance: '公司治理',
    investorInquiry: '投资者查询',
    investorContact: '投资者联系方式',
    announcements: '公告及通函',
    contact: '联系我们'
  },

  // 客户服务
  customerService: {
    title: '客户服务',
    welcome: '您好！有什么可以帮助您的吗？',
    phone: '电话咨询',
    email: '邮件咨询'
  },

  // 首页
  home: {
    carousel: {
      ariaLabel: '首页轮播横幅'
    },
    about: {
      title: '关于创美',
      description:
        '• 创美药业（股票代码：2289.HK）创立于2000年，是华南地区领先的现代医药供应链综合服务商。公司始终专注于医药非招标市场，以医药分销为核心，融合医药咨询、第三方物流与营销服务，依托四大现代化医药物流中心，配备先进的信息管理系统与高效自主配送体系，为客户提供安全、敏捷、一体化的供应链解决方案。凭借智能化、标准化的运营体系和可复制的拓展模式，业务覆盖广东，辐射福建、广西、海南等省份，持续巩固华南地区的领先优势。'
    },
    statsGrid: {
      title: '成为中国医药健康行业，最具市场竞争力服务商',
      primaryDistribution: '一级经销品种超80%',
      experience: '年行业积淀',
      suppliers: '家供应商',
      products: '产品品种',
      customers: '客户',
      logisticsCenters: '大物流中心',
      warehouseArea: '平方米仓储面积',
      vehicles: '台配送车辆'
    },
    advantages: {
      title: '核心优势',
      marketing: {
        title: '营销领航·聚力共赢',
        items: [
          {
            label: '深厚渠道资源',
            content: '汇聚超1500家供应商，拥有10年以上稳固合作根基，经营品规超15000个，一级经销占比达80%，是众多知名OTC品牌在广东市场的核心战略伙伴。'
          },
          {
            label: '广阔客户网络',
            content: '终端客户超万家，业务范围全省全覆盖，辐射到闽、桂、琼、湘等周边省市，在华南地区的医药非招标市场处于领先地位。'
          },
          {
            label: '资深专业团队',
            content: '核心团队拥有逾20年行业积淀，坚持内部培养与锻造，能深刻洞察客户需求，提供精准、敏捷的个性化营销解决方案与高效落地服务。'
          },
          {
            label: '卓越行业地位',
            content: '行业内唯一完全专注于非招标市场业务的大型医药流通企业；连续十余年位列「全国药品流通行业批发企业35强」「广东企业500强」。'
          },
          {
            label: '创新业务模式',
            content: '突破传统多元分销模式，构建「分销+仓促+配送」综合服务体系；通过渠道下沉实现一级代理直供终端，并自建B2B电商平台「创美e药」，打造线上线下融合的全渠道营销生态。'
          }
        ]
      },
      logistics: {
        title: '智慧物流·高效精准',
        items: [
          {
            label: '硬核基建实力',
            content: '拥有4大现代化医药物流中心，仓储总面积超 10万㎡；配备超 200辆自有运输车（冷藏车占比80%以上），支持「多品种、小批量、高频次」配送需求，可实现「10公里半径一日三配、50公里一日两配、250公里一日一配」。'
          },
          {
            label: '智能技术驱动',
            content: '集成AS/RS自动化立体库、EWM/WCS/TMS等智能管理系统，结合北斗实时定位与温湿度监控，实现仓储管理、运输调度及作业全流程自动化、可视化，确保高效精准、全程可控。'
          },
          {
            label: '三方物流标杆',
            content: '率先在广东省内通过医药新规第三方物流企业检查认证，创新实践B2B2C一体化仓配模式，为客户提供合规、专业的医药供应链解决方案。'
          },
          {
            label: '行业标准引领',
            content: '参与起草新版《药品物流服务规范》国家标准（GB/T 30335-2023），以创美实践智慧赋能行业标准制定，树立专业标杆。'
          }
        ]
      },
      digital: {
        title: '数智赋能·质效双升',
        items: [
          {
            label: '智能分销体系',
            content: '全面引入云计算、大数据、人工智能、5G和物联网等创新科技，将业务场景、GSP管控、物流服务深度融合，构建一体化医药供应链新生态。'
          },
          {
            label: '数字平台固基',
            content: '自建自营「创美e药」B2B电商平台，集电子处方、电子首营、自动入库等应用工具于一体，为医药交易提供全流程数字化解决方案。'
          },
          {
            label: 'AI全域赋能',
            content: '推进全流程信息化、营销AI辅助、RPA自动流程机器人办公，实现供应链全流程服务自动化、决策数据化、运营智能化。'
          }
        ]
      },
      quality: {
        title: '质量监管·安全省心',
        items: [
          {
            label: '全员质量文化',
            content: '恪守「质量第一、预防为主、全员参与」方针，将质量意识融入企业文化血脉。'
          },
          {
            label: '全程溯源体系',
            content: '建立完善的质量管理体系，实现对药品进、存、销、运各环节全过程可追溯、可跟踪，确保流转链条清晰透明。'
          },
          {
            label: '全时严格执行',
            content: '以超GSP标准实施常态化质量管控，通过定期巡检与突击飞检相结合，持续强化质量监管力度，坚守安全底线。'
          }
        ]
      }
    },
    news: {
      title: '公司动态',
      subtitle: '了解创美药业的最新发展和重要事件',
      viewAll: '查看全部动态'
    },
    partners: {
      title: '合作伙伴',
      subtitle: '与全球知名企业携手共进，共创美好未来'
    }
  },

  // 关于我们页面
  about: {
    hero: {
      title: '关于创美药业',
      subtitle: '专注医药分销，守护人类健康'
    },
    company: {
      hero: {
        title: '公司简介',
        subtitle: '专注医药分销，服务健康中国'
      },
      intro: {
        title: '关于创美',
        content: '创美药业（股票代码：02289.HK）成立于2000年，始终深耕医药流通市场，持续夯实医药分销业务，积极拓展第三方物流等增值业务，业务范围全面覆盖广东，辐射闽、桂、琼等省份，并依托高效协同的四大现代化医药物流中心，为客户提供精准适配的一体化供应链解决方案，已成为华南地区领先的现代医药供应链综合服务商。'
      },
      missionVision: {
        title: '使命与愿景',
        mission: {
          title: '公司使命',
          slogan: '创造健康美好生活',
          content: ''
        },
        vision: {
          title: '公司愿景',
          slogan: '成为中国医药健康产业最具市场竞争力服务商',
          content: ''
        }
      },
      mission: {
        title: '公司使命',
        content: ''
      },
      vision: {
        content: ''
      },
      culture: {
        title: '企业文化',
        coreValues: {
          title: '核心价值观'
        },
        spirit: {
          title: '企业精神',
          content: '实干进取，快乐奋斗'
        },
        businessPhilosophy: {
          title: '经营理念',
          content: '诚信经营、利他利众、合作共赢'
        },
        servicePhilosophy: {
          title: '服务理念',
          content: '真诚服务，真心付出'
        },
        employeePhilosophy: {
          title: '员工理念',
          content: '尊重、关爱、善待、培育'
        },
        employeeImage: {
          title: '员工形象',
          content: '活力、真诚、效率，以真理为中心'
        },
        workPhilosophy: {
          title: '工作理念',
          content: '坚韧、负责、合作、高效'
        }
      },
      values: {
        title: '核心价值观',
        innovation: {
          title: '创新',
          description: '持续创新，引领行业发展'
        },
        quality: {
          title: '品质',
          description: '追求卓越品质，确保药品安全'
        },
        integrity: {
          title: '诚信',
          description: '诚信经营，赢得客户信赖'
        },
        collaboration: {
          title: '协作',
          description: '团队协作，共创价值'
        }
      }
    },
    history: {
      hero: {
        title: '发展历程',
        subtitle: '25年砥砺前行，铸就行业典范'
      },
      title: '发展历程',
      subtitle: '从创立至今，创美药业始终坚持专业发展，不断完善医药分销服务体系',
      intro: '深耕医药非招标市场多年，从行业新锐到华南地区领先的现代化医药供应链服务商，创美药业的成长与蜕变，源于一段筚路蓝缕、锐意进取的发展征程。',
      timeline: {
        title: '重要里程碑'
      },
      1999: {
        title: '筹备阶段',
        description: '创美药业开始筹备，奠定发展基础。'
      },
      2005: {
        title: '业务扩展',
        description: '建立第一个现代化配送中心，业务范围扩展至广东全省，与多家知名药企建立合作关系。'
      },
      2010: {
        title: '区域布局',
        description: '在福建、广西设立分支机构，形成华南三省的分销网络，成为区域内重要的医药分销企业。'
      },
      2015: {
        title: '智慧升级',
        description: '投资建设现代化物流中心，引进先进的仓储管理系统，提升配送效率和服务质量。'
      },
      2020: {
        title: '数字化转型',
        description: '全方位数字化转型，建立智能化供应链管理系统，运用大数据技术提升运营效率。'
      },
      2024: {
        title: '服务创新',
        description: '在海南设立第四个配送中心，实现华南四省全覆盖，持续创新服务模式，提升客户体验。'
      }
    },
    honors: {
      title: '荣誉资质',
      hero: {
        title: '荣誉资质',
        subtitle: '专业认证，值得信赖'
      },
      intro: '伴随着综合实力的不断强大，创美药业的品牌影响力与价值也不断提升，一系列荣誉的获得，彰显了企业实力，也印证了企业不断追求卓越的坚实足迹。',
      dataNote: '（数据截至2025年）',
      list: {
        item1: '广东企业500强',
        years1: '连续15年',
        item2: '全国药品流通行业批发企业34强',
        years2: '荣登百强榜超14年',
        item3: '医药冷链最佳物流中心',
        years3: '连续6年',
        item4: '医药冷链物流服务推荐企业',
        years4: '连续6年',
        item5: '药品三方现代物流服务能力TOP50',
        years5: '连续2年',
        item6: '中国数智物流创新应用金蚂蚁创新奖',
        years6: '连续7年',
        item7: '现代医药物流技术试验基地（中心）',
        years7: '连续3年',
        item8: '医药物流配送优秀企业',
        years8: '连续4年',
        item9: '广东省诚信兴商企业',
        years9: '连续13年',
        item10: '2023年智慧医药供应链一体化服务"优秀案例奖"',
        item11: '2023年度最佳医药营销团队',
        item12: '2022年中国医药供应链锐意企业'
      },
      conclusion: '未来，在"创造健康美好生活"的使命引领下，创美药业将持续以加速奔跑的姿态，坚定迈向"中国医药健康产业最具市场竞争力服务商"的目标高地，为健康事业注入奔腾不息的创美动能！'
    },
    culture: {
      values: {
        title: '文化理念',
        subtitle: '创美药业秉承"诚信、创新、专业、共赢"的企业文化，致力于为员工创造良好的工作环境，为客户提供优质的服务，为社会创造更大的价值。'
      },
      teamwork: {
        title: '团队协作',
        desc: '凝聚团队力量，共创美好未来'
      },
      innovation: {
        title: '创新进取',
        desc: '勇于创新，追求卓越'
      },
      customer: {
        title: '客户至上',
        desc: '以客户需求为导向，提供优质服务'
      },
      quality: {
        title: '质量第一',
        desc: '严格质量管理，确保产品安全'
      },
      responsibility: {
        title: '社会责任',
        desc: '承担社会责任，回馈社会'
      },
      excellence: {
        title: '追求卓越',
        desc: '不断提升，追求卓越品质'
      }
    },
    organization: {
      hero: {
        title: '组织架构',
        subtitle: '科学管理，高效运营'
      },
      pageTitle: '组织架构',
      loading: '加载中...',
      empty: '暂无组织架构数据'
    },
    teamStyle: {
      hero: {
        title: '员工风采',
        subtitle: '专业团队，共创辉煌'
      },
      intro: {
        title: '专业团队·共创未来',
        content: '创美药业拥有一支专业、敬业的团队。我们注重员工的成长与发展，为员工提供良好的工作环境和发展平台，共同创造美好未来。'
      },
      highlights: {
        professional: {
          title: '专业团队',
          desc: '汇聚行业精英，打造专业化服务团队'
        },
        growth: {
          title: '成长平台',
          desc: '提供完善的培训体系和职业发展通道'
        },
        care: {
          title: '员工关怀',
          desc: '关注员工身心健康，营造温馨工作氛围'
        },
        achievement: {
          title: '共创辉煌',
          desc: '携手并进，共同创造美好未来'
        }
      },
      gallery: {
        title: '团队风采'
      }
    },
    video: {
      company: {
        title: '企业宣传片',
        subtitle: '通过视频了解创美药业的发展历程、企业文化和服务理念'
      },
      note: '注：请将上述视频链接替换为实际的企业宣传视频'
    },
    logistics: {
      hero: {
        title: '物流配送中心',
        subtitle: '专业物流，安全高效'
      },
      intro: {
        title: '物流中心简介',
        content: '公司拥有汕头、广州、深圳、珠海四大现代化物流中心，形成总面积超10万平方米的智能仓储集群，配备专业物流车队超200辆，其中冷藏车占比80%，全面保障药品储运品质。作为广东省首家通过新版第三方医药物流标准认证的企业，公司凭借先进的设施与管理体系，为客户提供多温层、全批次、可追溯的精准物流服务。'
      },
      features: {
        title: '核心优势'
      },
      storage: {
        title: '现代化仓储',
        desc: '配备先进的仓储设施，确保药品存储安全'
      },
      delivery: {
        title: '专业配送',
        desc: '专业的冷链配送车队，保障药品运输质量'
      },
      quality: {
        title: '质量保证',
        desc: '严格的质量管理体系，确保药品安全'
      },
      speed: {
        title: '快速响应',
        desc: '24小时内完成配送，满足客户需求'
      },
      efficiency: {
        title: '高效运营',
        desc: '智能化管理系统，提升运营效率'
      },
      coverage: {
        title: '广泛覆盖',
        desc: '覆盖华南地区50+城市'
      },
      stats: {
        area: '平方米仓储面积',
        vehicles: '辆配送车辆',
        cities: '个服务城市',
        delivery: '配送时效'
      }
    }
  },

  // 新闻资讯页面
  news: {
    hero: {
      title: '新闻资讯',
      subtitle: '了解创美最新的最新动态'
    },
    categories: {
      company: '公司新闻',
      media: '媒体报道'
    },
    readMore: '阅读更多',
    relatedNews: '相关新闻',
    detail: {
      readTime: '阅读时间',
      notFound: '新闻不存在',
      notFoundDesc: '抱歉，您访问的新闻不存在或已被删除'
    }
  },

  // 人才招聘页面
  careers: {
    backToList: '返回列表',
    emailSubjectTip: '请在邮件主题中注明应聘职位',
    fetchError: '获取职位详情失败',
    jobDescription: '职位描述',
    jobNotFound: '职位不存在',
    noJobs: '暂无招聘职位',
    requirements: '任职要求',
    responsibilities: '工作职责',
    sendResumeTo: '请将简历发送至',
    submitResume: '投递简历'
  },

  // 投资者关系页面
  investor: {
    hero: {
      title: '投资者关系',
      subtitle: '透明、及时的信息披露，与投资者共同成长'
    },
    financialReports: {
      hero: {
        title: '财务报告',
        subtitle: '透明公开的财务信息，为投资者提供全面的业绩数据'
      },
      filter: {
        all: '全部报告',
        annual: '年度报告',
        interim: '中期报告'
      },
      actions: {
        preview: '预览',
        download: '下载'
      },
      loading: '加载中...',
      empty: '暂无财务报告',
      pagination: {
        total: '共 {{total}} 条'
      }
    },
    announcements: {
      hero: {
        title: '公告及通函',
        subtitle: '查看公司最新的公告和通函文件'
      },
      sectionTitle: '公告及通函',
      yearSuffix: '年',
      preview: '预览',
      download: '下载',
      empty: '暂无公告',
      total: '共 {{total}} 条'
    },
    inquiry: {
      hero: {
        title: '投资者联系方式',
        subtitle: '为投资者提供便捷的联系方式和咨询服务'
      },
      companyName: '创美药业股份有限公司',
      financialPR: '财经公关公司',
      financialPRName: '智信财经公关顾问有限公司',
      address: '地址：',
      phone: '电话：',
      email: '邮箱：',
      postcode: '邮编：'
    },
    governance: {
      hero: {
        title: '公司治理',
        subtitle: '规范透明的公司治理结构，保障股东权益'
      },
      tabs: {
        info: '企业资料',
        governance: '企业管治',
        communication: '向股东发出公司通讯的方式'
      },
      companyInfo: {
        registeredOffice: '注册办事处',
        chinaHeadquarters: '中国总部',
        hkPrincipalPlace: '香港主要营业地点',
        companyWebsite: '公司网站',
        jointCompanySecretaries: '联席公司秘书',
        authorizedRepresentatives: '授权代表',
        hShareRegistrar: 'H股证券登记处',
        hkCentralSecurities: '香港中央证券登记有限公司',
        china: '中国',
        guangdong: '广东省',
        shantouLonghu: '汕头市龙湖区',
        songshanRoad: '嵩山北路235号',
        hongkong: '香港',
        wanchai: '湾仔',
        queensRoad: '皇后大道东248号',
        sunlightTower: '大新金融中心40楼',
        secretary1: '姚洁晞',
        secretary2: '黄慧玲',
        representative1: '姚洁晞',
        representative2: '郑玉燕',
        foshanChancheng: '佛山市禅城区',
        foshanRoad: '佛山大道北65号',
        queensRoad183: '湾仔皇后大道东183号',
        hopewellCentre: '合和中心17楼',
        room1712: '1712–1716室'
      },
      sections: {
        corporateGovernance: '企业管治',
        regulations: '规章制度',
        antiCorruption: '反贪污及举报政策与程序',
        reportingChannel: '举报渠道'
      },
      actions: {
        read: '阅读',
        download: '下载',
        loading: '加载中...',
        noDocuments: '暂无文件'
      },
      communication: {
        intro: '根据《香港联合交易所有限公司证券上市规则》，公司已采用以电子方式发布公司通讯之安排，并在公司网站',
        and: '及香港联合交易所「披露易」网站',
        introEnd: '上向公司股东提供及发布公司通讯。',
        definition: '「公司通讯」指公司已发出或将予发出以供其任何股东参照或采取行动的任何文件，其中包括但不限于(a)董事报告、年度账目以及审计报告副本以及（如适用）财务摘要报告；(b)中期报告及其中期报告摘要（如适用）；(c)会议通知；(d)上市文件；(e)通函；及(f)代表委任表格。',
        downloadNotice: '公司登记股东和非登记股东用作选取可供采取行动的公司通讯之收取方式及/或要求印刷本的通知信函及回条可透过以下链接下载：',
        registeredLink: '供登记股东使用的以电子方式发布公司通讯之安排之通知信函及回条',
        nonRegisteredLink: '供非登记股东使用的以电子方式发布公司通讯之安排之通知信函及回条',
        hkexDownload: '同时，股东亦可于香港联合交易所「披露易」网站下载上述通知信函及回条。',
        emailNotice: '如股东已提供其有效电子邮件地址，股东于每次公司发布可供采取行动的公司通讯时将会以电子邮件收到可供采取行动的公司通讯。如股东需收取公司通讯印刷版，请填写及向公司股份过户处提交以上回条，或发送电子邮件至',
        emailNoticeEnd: '，并注明股东姓名、地址以及提出收取公司通讯印刷版的要求。请注意，收取未来公司通讯印刷版之指示由收悉股东指示当日起计一年内有效，此后将过期。'
      }
    },
    stock: {
      service: '投资者服务',
      listed: 'A股上市',
      marketCap: '市值',
      volume: '成交量',
      loading: '加载中...',
      open: '今开',
      close: '昨收',
      high: '最高',
      low: '最低',
      yesterday: '昨收',
      intraday: '分时走势',
      updateTime: '更新时间',
      refresh: '刷新',
      tabs: {
        chart: '分时',
        detail: '日K'
      },
      bidAsk: {
        level: '档位',
        bid: '买价',
        bidVolume: '买量',
        ask: '卖价',
        askVolume: '卖量',
        levelLabel: '买{{level}}/卖{{level}}'
      }
    }
  },

  // 联系我们页面
  contact: {
    hero: {
      title: '联系我们',
      subtitle: '我们期待与您的沟通交流'
    },
    info: {
      title: '联系信息',
      addressLabel: '地址/ADD：',
      phoneLabel: '电话/TEL：',
      postcodeLabel: '邮编/P.C.：'
    },
    companies: [
      {
        nameCn: '创美药业股份有限公司',
        nameEn: 'Charmacy Pharmaceutical Co., Ltd.',
        address: '汕头市龙湖区嵩山北路235号'
      },
      {
        nameCn: '广东创美药业有限公司',
        nameEn: 'Guangdong Charmacy Pharmaceutical Co., Ltd.',
        address: '佛山市禅城区祖庙街道汾江北路38号首层11-14号、64-65号，四层79-103号'
      },
      {
        nameCn: '珠海创美药业有限公司',
        nameEn: 'Zhuhai Chuangmei Hengxiang Pharmaceutical Co., Ltd.',
        address: '珠海市香洲区华威路919号1栋二楼'
      },
      {
        nameCn: '广州创美药业有限公司',
        nameEn: 'Guangzhou Charmacy Pharmaceutical Co., Ltd.',
        address: '广州市南沙区东涌镇沥裕街33号'
      },
      {
        nameCn: '惠州创美药业有限公司',
        nameEn: 'Huizhou Charmacy Pharmaceutical Co., Ltd.',
        address: '博罗县罗阳街道寨头创享大厦第4层第06房'
      },
      {
        nameCn: '深圳创美药业有限公司',
        nameEn: 'Shenzhen Charmacy Pharmaceutical Co., Ltd.',
        address: '深圳市龙岗区保安社区赐昌路8号创美药业'
      }
    ],
    financialPR: {
      title: '财经公关公司',
      nameCn: '皓天财经集团控股有限公司',
      nameEn: 'Wonderful Sky Financial Group Holdings Limited',
      addressLabel: '地址：',
      addressSz: '深圳市福田区金田路4028号荣超经贸中心1412室',
      hkAddressLabel: '香港主要营业地址：',
      addressHk: '香港湾仔港湾道6-8号瑞安中心9楼'
    },
    feedback: {
      title: '投诉与建议',
      subtitle: '请填写以下信息，我们会尽快与您联系',
      name: '姓名',
      namePlaceholder: '请输入您的姓名',
      nameRequired: '请输入您的姓名',
      phone: '电话',
      phonePlaceholder: '请输入您的电话',
      phoneRequired: '请输入您的电话',
      phoneInvalid: '请输入有效的手机号码',
      email: '邮箱（选填）',
      emailPlaceholder: '请输入您的邮箱',
      emailInvalid: '请输入有效的邮箱地址',
      category: '类别',
      categoryPlaceholder: '请选择类别',
      categoryRequired: '请选择类别',
      categoryComplaint: '投诉',
      categorySuggestion: '建议',
      categoryCorruption: '贪污举报',
      subject: '主题',
      subjectPlaceholder: '请输入主题',
      subjectRequired: '请输入主题',
      message: '留言内容',
      messagePlaceholder: '请输入您的留言内容',
      messageRequired: '请输入留言内容',
      submit: '提交',
      submitSuccess: '提交成功！我们会尽快与您联系。',
      submitError: '提交失败，请稍后重试。'
    },
    shareholderCommunication: {
      title: '向股东发起通讯的方式'
    }
  },

  // 404页面
  notFound: {
    title: '页面未找到',
    description: '抱歉，您访问的页面不存在或已被移除。',
    backHome: '返回首页',
    goBack: '返回上页'
  },

  // 通用
  common: {
    admin: '管理员',
    back: '返回',
    backToList: '返回列表',
    close: '关闭',
    languageSwitch: '语言切换',
    minutes: '分钟',
    noData: '暂无数据',
    selectLanguage: '选择语言'
  },

  // SEO 配置
  seo: {
    home: {
      title: '创美药业 - 创造健康美好生活',
      description: '创美药业专注于医药分销与健康服务，致力于创造健康美好生活',
      keywords: '创美药业,医药分销,健康服务,药品供应链'
    },
    about: {
      title: '关于我们 - 创美药业',
      description: '了解创美药业的发展历程、企业文化和核心价值观',
      keywords: '创美药业,公司简介,企业文化,发展历程'
    },
    news: {
      title: '公司动态 - 创美药业',
      description: '了解创美药业的最新发展和重要事件',
      keywords: '创美药业,公司新闻,行业动态,企业资讯'
    },
    careers: {
      title: '人才招聘 - 创美药业',
      description: '加入创美药业，共创美好未来',
      keywords: '创美药业,招聘,职位,人才'
    },
    investor: {
      title: '投资者关系 - 创美药业',
      description: '创美药业投资者关系信息',
      keywords: '创美药业,投资者关系,财务报告,公司治理'
    },
    contact: {
      title: '联系我们 - 创美药业',
      description: '联系创美药业，我们期待与您沟通',
      keywords: '创美药业,联系方式,客户服务'
    }
  }
};
